import { render, staticRenderFns } from "./article-projects.vue?vue&type=template&id=1a1c3b56&scoped=true"
import script from "./article-projects.vue?vue&type=script&lang=js"
export * from "./article-projects.vue?vue&type=script&lang=js"
import style0 from "./article-projects.vue?vue&type=style&index=0&id=1a1c3b56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c3b56",
  null
  
)

export default component.exports